import type { Dict } from "./types";

export const landing: Dict = {
  "landing.tagline": {
    tr: "Üye olun, etkinlik biletlerinizi alın. Etkinlik anında içecek siparişi verin. Puan toplayın. Sıra beklemeyin.",
    en: "Become a member, get your event tickets. Order drinks during the event. Collect points. Skip the queue.",
    de: "Werde Mitglied und hol dir deine Event-Tickets. Bestelle Getränke während der Veranstaltung. Sammle Punkte. Keine Warteschlangen.",
    fr: "Devenez membre, achetez vos billets d'événement. Commandez des boissons pendant l'événement. Accumulez des points. Ne faites pas la queue.",
    ar: "سجل، احصل على تذاكر فعالياتك. اطلب المشروبات فورًا في الفعالية. اجمع النقاط. لا تنتظر في الطابور.",
    es: "Hazte miembro, consigue tus entradas para eventos. Pide bebidas durante el evento. Acumula puntos. Sáltate la cola.",
  },
  "landing.cta.signup": {
    tr: "Üye ol.",
    en: "Join now.",
    de: "Mitglied werden.",
    fr: "S'inscrire",
    ar: "سجل الآن",
    es: "Únete ahora.",
  },
  "landing.cta.login": {
    tr: "Zaten üyeyim",
    en: "I'm already a member",
    de: "Ich bin bereits Mitglied",
    fr: "Je suis déjà membre",
    ar: "أنا عضو بالفعل",
    es: "Ya soy miembro",
  },
  "landing.upcoming": {
    tr: "Yaklaşan etkinlikler",
    en: "Upcoming events",
    de: "Kommende Events",
    fr: "Événements à venir",
    ar: "الفعاليات القادمة",
    es: "Próximos eventos",
  },
  "landing.buyTicket": {
    tr: "Bilet al",
    en: "Get tickets",
    de: "Tickets kaufen",
    fr: "Acheter des billets",
    ar: "اشترِ تذكرة",
    es: "Conseguir entradas",
  },
};
